import favoritesStore from "../store/store";
import { type ADD_TO_ORDERED_FAVORITE_ID_LISTActionMessage, addToOrderedFavoriteIdList, } from "../actions/v2/addToOrderedFavoriteIdList";
import { mutator } from "satcheljs";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import { isMonarchMultipleAccountsEnabled } from "owa-account-source-list";

const defaultExport: (actionMessage: ADD_TO_ORDERED_FAVORITE_ID_LISTActionMessage) => void = 
// eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- BASELINE. Do not copy!
mutator(addToOrderedFavoriteIdList, actionMessage => {
    const favoriteData = actionMessage.favoriteData;
    const accountKey = getAccountKeyForMailboxInfo(favoriteData?.mailboxInfo ?? getModuleContextMailboxInfo());
    
    const orderedOutlookFavoritesIds = isMonarchMultipleAccountsEnabled()
        ? favoritesStore().orderedCombinedOutlookFavoritesIds
        : favoritesStore().favoriteTreeData.get(accountKey)?.orderedOutlookFavoritesIds;
    
    orderedOutlookFavoritesIds?.push(favoriteData.favoriteId);
});
export default defaultExport;
